/** @format */

import React from 'react'
import Navbar from "./navbar";

class Shopstatic extends React.Component {
    render() {
        return (
            <>
                <Navbar />
                <section className='container py-1 margin-shop text-center'>
                    <div className='row'>
                        <div className='col-9 col-md-12 p-3 mt-3'>
                            <div className='login-cards'>
                                <h6 className='  download-app-text '>
                                    To place orders <b>Download</b> our mobile app
                                    and<b> shop</b> Now!!!
                                </h6>
                                <div className='col text-middle mt-1 margin-shop'>
                                    <button
                                        type='submit'
                                        className='btn btn-success btn-lg px-3'>
                                        Click to download
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
               

            </>
        )
    }
}
export default Shopstatic
